import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { SetInitialStateFacade } from '../../../../../common/models';
import { TransportManagementSearchCriteria } from '../models/transport-management.model';
import {
  TransportManagementTransportOrderLoad,
  TransportManagementTransportOrderInitialState,
} from './transport-management-transport-order.actions';
import {
  TransportManagementTransportOrderState,
  TransportManagementTransportOrderStateModel,
} from './transport-management-transport-order.state';
import { Observable } from 'rxjs';
import { TransportManagementTileItem } from '../models';

@Injectable({ providedIn: 'root' })
export class TransportManagementTransportOrderFacade implements SetInitialStateFacade {
  listDto$: Observable<TransportManagementTransportOrderStateModel> = this.store.select(
    TransportManagementTransportOrderState.getState,
  );
  items$: Observable<TransportManagementTileItem[]> = this.store.select(
    TransportManagementTransportOrderState.getItems,
  );
  loaded$: Observable<boolean> = this.store.select(TransportManagementTransportOrderState.getLoaded);
  isMoreButtonVisible$: Observable<boolean> = this.store.select(
    TransportManagementTransportOrderState.isMoreButtonVisible,
  );
  isReportLimitationExceeded$: Observable<boolean> = this.store.select(
    TransportManagementTransportOrderState.isReportLimitationExceeded,
  );

  constructor(private store: Store) {}

  load(searchCriteria: TransportManagementSearchCriteria): void {
    this.store.dispatch(new TransportManagementTransportOrderLoad(searchCriteria));
  }

  setInitialState(): void {
    this.store.dispatch(new TransportManagementTransportOrderInitialState());
  }
}
